@if (team) {
  <h1 mat-dialog-title>
    <span>{{messages[sendMode].title}}</span>
  </h1>
}
@if (team) {
  <div mat-dialog-content>
    <span class="info">{{messages[sendMode].info}}</span>
    @if (form) {
      <form class="form" [formGroup]="form" padding>
        @if (sendMode !== SendMode.ALLOWANCE_TO_WALLIT) {
          <mat-form-field formFieldName="amount">
            <mat-label>Amount to send ($)</mat-label>
            <input type="number" matInput placeholder="" formControlName="amount">
          </mat-form-field>
        }
        <mat-form-field formFieldName="message">
          <mat-label>Message</mat-label>
          <textarea class="message" rows="4" matInput formControlName="message"></textarea>
        </mat-form-field>
      </form>
    }
    <app-team-member-selector [team]="team" class="teamlist" (membersSelectedEvent)="membersChanged($event)"></app-team-member-selector>
  </div>
}
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button [disabled]="members.length === 0 || (!form.valid && sendMode !== SendMode.ALLOWANCE_TO_WALLIT) || uploading" class="donebutton" color="primary" (click)="sendRewards()">Send</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
